import reports from './reports';
import pivot from './pivot';
import anonymous from './anonymous';
import fraudProtected from './fraudProtected';
import fraudSuspicious from './fraudSuspicious';
import fraudRejected from './fraudRejected';
import adMonetization from './adMonetization';
import crossDevice from './crossDevice';
import skan from './skan';
import skanSummary from './skanSummary';
import unifiedReport from './unifiedReport';
import creativeExplore from './creativeExplore';
import retention from './retention';

export default [
    reports,
    pivot,
    anonymous,
    fraudProtected,
    fraudSuspicious,
    fraudRejected,
    adMonetization,
    crossDevice,
    skan,
    skanSummary,
    unifiedReport,
    creativeExplore,
    retention,
];
